import { Button, Modal } from 'gatorcomponents';
import React from 'react';
import * as Styles from './CloudFlareGenericModal.styles';
import PropTypes from 'prop-types';

export const CloudFlareGenericModal = ({
  onClose,
  icon,
  testId = 'cloudflare-generic-modal',
  title = 'modal title',
  message = 'modal message',
  buttonLabel = 'button label',
  buttonAction,
  loading,
}) => {
  const handleOnClose = () => {
    onClose && onClose();
  };

  const handleButtonAction = () => {
    buttonAction && buttonAction();
  };

  return (
    <Modal onClose={handleOnClose} maxWidth={502} testId={testId}>
      <Styles.Wrapper>
        {icon && icon}
        {title && <Styles.Title>{title}</Styles.Title>}
        {message && <Styles.Message>{message}</Styles.Message>}
        <Styles.ButtonContainer>
          <Button
            label={buttonLabel}
            onClick={handleButtonAction}
            size="large"
            loading={loading}
            disabled={loading}
          />
        </Styles.ButtonContainer>
      </Styles.Wrapper>
    </Modal>
  );
};

CloudFlareGenericModal.propTypes = {
  onClose: PropTypes.func,
  icon: PropTypes.node,
  title: PropTypes.string,
  message: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonAction: PropTypes.func,
  loading: PropTypes.bool,
};

export default CloudFlareGenericModal;
